module.exports = __webpack_public_path__ + "static/media/avatar-23.6bdc84b5.svg";